import './listing.scss';
import Dialog from '../dialog/dialog';
import { isMobile } from '../../assets/js/_mq';

class Listing {
	constructor(element) {
		const options =
			(element.dataset.listingOptions ? JSON.parse(element.dataset.listingOptions) : null) ||
			{};

		this.options = Object.assign(
			{
				urlRoot: null,
				isDetailView: false
			},
			options
		);

		this.element = element;

		if (!this.element) {
			return;
		}

		this.items = this.element.querySelectorAll('[data-listing-target]');
		this.targets = this.element.querySelectorAll('[data-listing-id]');

		this.init();
	}

	init() {
		// Mobile view
		this.dialog = new Dialog();

		isMobile.addListener(this.toggleMobile.bind(this));
		this.toggleMobile(isMobile, true);

		// Init elements
		this.items.forEach(element => {
			element.addEventListener(
				'click',
				event => {
					event.preventDefault();

					this.activate(element);
				},
				false
			);

			// Initial state
			this.activate(element, true);

			// Add animation
			new window.MDCRipple(element);
		});

		// Browser history
		window.addEventListener('popstate', event => {
			const targetId = event.state ? event.state.id : null;

			this.toggle(targetId, true);
		});
	}

	activate(element, initial) {
		const isActive = element.classList.contains('is-active');

		// Prevent reactivation of already active view
		// Prevent dialog from opening on mobile unless we are on detail view
		if (isActive && (!initial || (this.isMobile && !this.options.isDetailView))) {
			element.classList.remove('is-active');

			return;
		}

		const targetId = element.getAttribute('data-listing-target');
		const targetUrl = element.getAttribute('href');

		const url = isActive ? this.rootUrl : targetUrl;
		const id = isActive ? null : targetId;

		this.toggle(targetId, initial ? isActive : !isActive, initial);

		if (!initial) {
			window.history.pushState(
				{
					id
				},
				'',
				url
			);
		}
	}

	toggle(targetId, show, initial) {
		if (!initial) {
			this.items.forEach(element => {
				const id = element.getAttribute('data-listing-target');

				if (id === targetId) {
					element.classList.toggle('is-active', show);
				} else {
					element.classList.remove('is-active');
				}
			});
		}

		this.targets.forEach(element => {
			const id = element.getAttribute('data-listing-id');
			const title = element.querySelector('[data-listing-title]');

			if (id === targetId) {
				if (!initial) {
					element.classList.toggle('is-active', show);
				}

				if (this.isMobile && (!initial || (show && this.options.isDetailView))) {
					this.dialog.toggle(element, show, {
						title: title ? title.innerHTML : null,
						onClose: () => {
							this.toggle(targetId);

							window.history.pushState(
								{
									id: null
								},
								'',
								this.options.urlRoot
							);
						}
					});
				}
			} else {
				if (!initial) {
					element.classList.remove('is-active');
				}
			}
		});
	}

	toggleMobile(event, initial) {
		this.isMobile = event.matches;

		// Workaround for missing state management: Properly re-render by reloading
		if (!initial) {
			window.location.reload();
		}
	}
}

document.querySelectorAll('[data-init="listing"]').forEach(element => {
	new Listing(element);
});
